import ImageWithFallback from "components/ImageWithFallback"
import Isotope from "isotope-layout"
import CategoryCard from "plugin/CategoryShortcuts/CategoryCard"

import IsotopeCards from "plugin/CategoryShortcuts/IsotopeCards"
import MasonryCard from "plugin/CategoryShortcuts/MasonryCard"
import React, { Component } from "react"
import { Link } from "react-router-dom"
import { Card, Container } from "semantic-ui-react"
import cmsStore from "stores/cmsStore"
import "style/CategoryCard.scss"

window[ "Isotope" ] = Isotope

export default class CategoryShortcuts extends Component {

  render() {
    const { category } = this.props
    const hasData = category && category.children.length > 0
    const title = this.props.title
    const useTitlebar = title && hasData
    const { masonryCategories } = cmsStore.config.plugin
    const isRoot = !category || category.map_id === undefined
    return (
      <div className="MasonryContainer">
        {hasData && this.props.children}
        {hasData && <div className="">
          {useTitlebar && <h2 className="mt2 ttu">{title}</h2>}
          {masonryCategories && <div>
            {hasData && <IsotopeCards key={category.map_id}>
              <div className="grid-sizer"/>
              {console.log("map_id",category.map_id)}
              {category.children.map( childCategory => {
                return <MasonryCard className=""
                    fallback={"//placehold.it/420x240/929673/&text=X"}
                  onReady={this.handleReady}
                  hasParents={category.map_id} parents={[ category.map_id ]} key={childCategory.map_id}
                  category={childCategory}/>
              } )}
              {/*isRoot && <Link
                key={"custom-link-rk"}
                title={"Shop the Look"}
                to={`/bildwelt/`}
                className={`MasonryCard grid-item landscape `}>
                <div className="img-overlay cover" style={{ background: 'url("/Shop-the-Look.jpg")' }}/>
            </Link>*/}
            </IsotopeCards>
            }
          </div>}
          
          {!masonryCategories && <div className="mb3">
            <Card.Group itemsPerRow={4} doubling>
              {category.children.map( subcat => {
                {console.log("map_id",subcat.map_id)}
                //Kundenspezifische Kategorieausblendung
                if(subcat.map_id == ".89."){
                  return false
                }
                return <CategoryCard
                    fallback={"//placehold.it/420x240/929673/&text=X"}
                    hasParents={category.map_id} parents={[ category.map_id ]} key={subcat.map_id}
                                     category={subcat}/>
              } )}
            </Card.Group>
          </div>}
        </div>}

      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/theme/moderntimes/plugin/CategoryShortcuts/CategoryShortcuts.js